export const keys = {
    IntegrationKey: 'dc21a410-71bb-4b65-a450-df1902bad451',
}